import { render, staticRenderFns } from "./UserRegistrationModal.vue?vue&type=template&id=79bcc9f4&scoped=true&"
import script from "./UserRegistrationModal.vue?vue&type=script&lang=js&"
export * from "./UserRegistrationModal.vue?vue&type=script&lang=js&"
import style0 from "./UserRegistrationModal.vue?vue&type=style&index=0&id=79bcc9f4&lang=scss&scoped=true&"
import style1 from "./UserRegistrationModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bcc9f4",
  null
  
)

export default component.exports